<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="RecordId"
      ref="list"
      unit="工艺数据"
      :page="page"
      :show-checkbox="multiple"
      :show-query="false"
      :query-params="params"
      :get-data-func="api.list"
      @check-change="checkChange"
      v-if="trendShow"
      urlHash="facility/equipment/craftdata"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <el-button type="danger" @click="_del">删除</el-button>
      </template>
      <template slot="table">
        <slot name="column">
          <el-table-column label="操作" fixed="right" align="center" width="160">
            <template slot-scope="{ row }">
              <el-button type="text" @click="_edit(row)">详情</el-button>
            </template>
          </el-table-column>
        </slot>
      </template>
    </list>

    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template> 
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import editDialog from './editDialog'

export default {
  mixins: [listMixin],
  components: { list, editDialog },
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require('@/api/equipment/craftdata').default,
      trendShow: true,
      params: {
        ProductName: '',
        MouldName: '',
      },
      tempParams: {
        //    ProgrammeType: 1
      },
      ids: [],
    }
  },
  mounted(){

  },
  methods: {
    getDatas(id){
      this.params.EquipmentId=id;
      this.$refs.list.query(this.params);
    },
    checkChange(ids) {
      this.ids = ids.map(v => {
        return v.RecordId
      })
    },
    _edit(row) {
      this.$refs.editDialog.openDetails(row);
    },
    _del() {
      if (this.ids.length === 0) {
        this.$message({ type: 'warning', message: '请选择删除的数据' })
        return
      }
      this.$confirm('确定删除这些记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.delete({ Ids: this.ids }).then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.reload()
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
  }
}
</script>
